import { FC } from 'react';

interface GeneralNotesProps {
  value: string;
  disabled?: boolean;
  readonly?: boolean;
  onChange?: (value: string) => void;
}

export const GeneralNotes: FC<GeneralNotesProps> = ({ value, disabled, readonly, onChange }) => {
  if (readonly && !value) return null;

  return (
    <section className="flex flex-col gap-2">
      <p className="m-0! [font-size:var(--fs-l4)]! font-semibold text-(--neutral-black-NB900)!">
        General Notes
      </p>
      {readonly ? (
        <p className="m-0! [font-size:var(--fs-p5)]! text-(--neutral-black-NB700)!">{value}</p>
      ) : (
        <textarea
          value={value}
          disabled={disabled}
          onChange={(event) => onChange?.(event.target.value)}
          placeholder="Required: Add general notes here..."
          className="min-h-36 w-full border! border-(--neutral-white-NW800)! bg-(--neutral-white-NW1000) rounded-[10px]! px-3 py-3"
        />
      )}
    </section>
  );
};
